import FakeStore from "../commons/FakeStore";

const Fetcher = {
    abortSignal: null,

    query(type, uri, datas={}, headers={}, containsfile=false) {
        const values = Fetcher.compileDatas(datas, !containsfile);
        const header = Fetcher.compileHeader({
            ...(containsfile ? {} : {'Content-Type': 'application/json'}),
            ...headers,
            ...(FakeStore.token ? {Authorization: `Bearer ${FakeStore.token}`} : {}),
            ...(FakeStore.browserId ? {'X-Http-Api-Id': FakeStore.browserId} : {}),
        });
        return new Promise((resolve, reject) => {
            let q = {
                method: type,
                headers: header,
                cache: 'no-cache',
                mode: 'cors',
                signal: Fetcher.abortSignal
            };

            if (['POST', 'PUT'].indexOf(type) !== -1) {
                q.body = values;
            }

            fetch(uri, q)
            .then(async (res) => {
                const contentType = res.headers.get('Content-Type') || '';
                if (contentType.indexOf('json') !== -1) {
                    const result = await res.json();
                    if (!res.ok || result.error) {
                        reject(result.error ? result : { error: true, message: result.message || `HTTP ${res.status}` });
                        return;
                    }
                    resolve(result);
                    return;
                }

                const text = await res.text();
                reject({
                    error: true,
                    message: text || `HTTP ${res.status}`
                });
            })
            .catch(error => {
                reject(error);
            });
        });
    },

    get(uri, headers={}) {
        return Fetcher.query('GET', uri, {}, headers);
    },

    post(uri, datas={}, headers={}, containsfile=false) {
        return Fetcher.query('POST', uri, datas, headers, containsfile);
    },

    put(uri, datas={}, headers={}) {
        return Fetcher.query('PUT', uri, datas, headers);
    },

    delete(uri, headers={}) {
        return Fetcher.query('DELETE', uri, {}, headers);
    },

    compileDatas(datas, tojson=true) {
        if (tojson) {
            return JSON.stringify(datas);
        }

        let compiled = new FormData();

        for (let x in datas) {
            compiled.append(x, datas[x]);
        }

        return compiled;
    },

    compileHeader(headers) {
        return new Headers(headers);
    }

};

export default Fetcher;
